module.exports = __webpack_public_path__ + "img/shipment-tracking-color.18aa87a5.png";